import i18n, { LanguageType } from '@utils/i18n';

import { userActions } from '@modules';
import { globalActions } from '@modules/global';
import { TMiddleware } from '@modules/types';

import { checkActionsType } from './utils';

export const setLang: TMiddleware = store => next => action => {
  const { defaultLang, languages } = CONST.i18n;
  const state = store.getState();

  if (checkActionsType(action, [globalActions.setLang])) {
    const language = action.payload;
    i18n.changeLanguage(language);

    const { isLoggedIn } = state.login;
    const shortLang = state.user.data?.language_code?.slice(0, 2);
    if (isLoggedIn && language !== shortLang) {
      store.dispatch(userActions.editUser({ language_code: languages[language].code }));
    }
  }

  if (checkActionsType(action, [userActions.getUserData.fulfilled])) {
    const shortLang = action.payload.data.language_code.slice(0, 2);
    const { lang } = state.global;
    if (!shortLang) {
      store.dispatch(userActions.editUser({ language_code: languages[lang ?? defaultLang].code }));
    } else if (shortLang !== lang) store.dispatch(globalActions.setLang(shortLang as LanguageType));
  }

  return next(action);
};

export default setLang;
